import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const EmptyStateRoot = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 48px 24px;
	text-align: center;
`;

export const EmptyStateIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 120px;
	height: 120px;

	svg {
		width: 100%;
		height: 100%;
	}
`;

export const EmptyStateTitle = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 14px;
	font-weight: 500;
	line-height: 1.4;
`;
